import React, { useEffect, useState } from 'react';
import { createStyles, makeStyles, Tab, Tabs } from '@material-ui/core';
import { Theme, withStyles } from '@material-ui/core/styles';
import UtilService from '../../../helper/service';
import roles from '../../../helper/roles';
import { useHistory } from 'react-router';
import {
  ANALYZE_TABBAR_TITLES,
  ANALYZE_TABBAR_TITLES_NO_REPORT_COMPARE,
  ANALYZE_TABBAR_TITLES_ONLY_PARTICIPANT,
} from '../../../config/mock';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { removeComparePath } from '../../../store/actions/creator/compare';

const useStyles = makeStyles(() => ({
  liveBadge: {
    width: 34,
    height: 16,
    color: 'white',
    fontFamily: 'roboto-bold',
    background: '#ED564A',
    fontSize: '8px',
    marginLeft: '8px',
    borderRadius: '4px'
  },
  containerCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
}));

interface IProps {
  isMobile: boolean
}

function AnalyzeTopTabs(props: IProps) {

  const classes = useStyles();
  const history = useHistory();
  const { isMobile } = props;
  const [tabBar, setTabBar] = useState('/participants');
  const { currentSession, all } = useSelector((state: any) => state.analysis);
  const participants = useSelector((state: any) => state.experience.participants);
  const { session_status, session_type } = currentSession ? currentSession : participants.session;
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""

  const dispatch = useDispatch();
  const isDisableReportCompare = (session_status === 'UPCOMING' || (session_type === 'MODERATED' && session_status === 'LIVE') || (session_type === 'ASYNC' && all.length === 0 && session_status !== 'COMPLETED'))

  useEffect(() => {
    if (session_type === 'REELS') {
      setTabBar('/participants');
    } else {
      setTabBar('/overview');
    }
  }, []);

  useEffect(() => {
    if (!location.pathname.includes('/creator/experience-manager')) {
      setTabBar('/participants');
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!!loginUserData) {
      let _tabBar = '/' + history.location.pathname.split('/')[3];
      if (UtilService.checkTrialAccess(loginUserData, roles['trial']['experiences'])) {
        _tabBar = '/' + history.location.pathname.split('/')[4];
      }
      setTabBar(_tabBar)
    }
  }, [history.location, loginUserData]);

  const handleChange = ({ }, newValue: string) => {
    dispatch(removeComparePath());
    setTabBar(newValue);
    const currentSessionCode = localStorage.getItem("session_code") ? localStorage.getItem("session_code") : "";
    const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
    let url = `/creator/experience-manager${newValue}/${currentSessionCode}`;
    if (!!userData) {
      if (UtilService.checkTrialAccess(userData, roles['trial']['experiences'])) {
        url = `/subscriber/creator/experience-manager${newValue}/${currentSessionCode}`;
      }
    }
    history.push(url, { session_id: localStorage.getItem("session_id") ? localStorage.getItem("session_id") : "" });
  };

  return (
    <AntTabs value={tabBar} onChange={handleChange} aria-label="participant manage tabs">
      {
        (session_type === 'REELS') ?
          (
            ANALYZE_TABBAR_TITLES_ONLY_PARTICIPANT.map((t, i) =>
              (isMobile && t.id === 3) ? (
                <DisableAntTab
                  key={i}
                  label={
                    <div className={classes.containerCenter}>
                      <div>{t.label}</div>
                    </div>
                  }
                  href={t.path}
                  value={t.path} {...a11yProps(i)}
                  labelvalue={t.label}
                  session_type={session_type}
                  participants={participants}
                />
              ) : (
                <AntTab
                  key={i}
                  label={
                    <div className={classes.containerCenter}>
                      <div>{t.label}</div>
                      {i === 2 && session_type === 'MODERATED' && session_status === 'LIVE' &&
                        <div className={clsx(classes.liveBadge, classes.containerCenter)}>LIVE</div>
                      }
                    </div>
                  }
                  href={t.path}
                  value={t.path} {...a11yProps(i)}
                  labelvalue={t.label}
                  session_type={session_type}
                  participants={participants}
                />
              )
            )
          )
          : (isDisableReportCompare ? ANALYZE_TABBAR_TITLES_NO_REPORT_COMPARE : ANALYZE_TABBAR_TITLES)
            .map((t, i) =>
              (isMobile && ((t.id === 3 || t.id === 4))) ? (
                <DisableAntTab
                  key={i}
                  label={
                    <div className={classes.containerCenter}>
                      <div>{t.label}</div>
                    </div>
                  }
                  href={t.path}
                  value={t.path} {...a11yProps(i)}
                  labelvalue={t.label}
                  session_type={session_type}
                  participants={participants}
                />
              ) : (
                <AntTab
                  key={i}
                  label={
                    <div className={classes.containerCenter}>
                      <div>{t.label}</div>
                      {i === 1 && session_type === 'MODERATED' && session_status === 'LIVE' &&
                        <div className={clsx(classes.liveBadge, classes.containerCenter)}>LIVE</div>
                      }
                    </div>
                  }
                  href={t.path}
                  value={t.path} {...a11yProps(i)}
                  labelvalue={t.label}
                  session_type={session_type}
                  participants={participants}
                />
              )
            )
      }
    </AntTabs>

  );

}
export default AnalyzeTopTabs;

function a11yProps(index: any) {
  return {
    id: `nav-tab-${index}`,
    'aria-controls': `nav-tabpanel-${index}`,
  };
}

interface StyledTabProps {
  label: any;
  href?: string;
  value: string;
  labelvalue: string;
  session_type: string;
  participants: any;
}
const checkParticipantsSessionStatus = (participants: any) => {
  if (participants && participants.participants) {
    return participants.participants.some((value: any) => {
      return value.participant_status === 'COMPLETED'
    });
  } else {
    return true
  }
}

const AntTab = withStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: 0,
      textTransform: 'none',
      minWidth: 38,
      fontWeight: 'lighter',
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      minHeight: '35px',
      color: "#697683",
      fontFamily: [
        'roboto-regular',
      ].join(','),
      '@media screen and (min-width: 375px) and (max-width: 599px)': {
        fontSize: 14,
        marginLeft: 5,
        marginRight: 5
      },
      '@media screen and (max-width: 374px)': {
        minWidth: 30,
        fontSize: 12,
        marginLeft: 4,
        marginRight: 4
      },
      '&:hover': {
        color: '#40a9ff',
        opacity: 1,
      },
      '&$selected': {
        color: '#017AEF',
        fontWeight: 'normal',
        fontFamily: 'roboto-bold'
      },
      '&:focus': {
        color: '#017AEF',
      },
    },
    selected: {},
  }),
)((props: StyledTabProps) =>
  <Tab disableRipple
    disabled={props.labelvalue === 'Comparison' && props.session_type === 'ASYNC' && !checkParticipantsSessionStatus(props.participants) ? true : false}
    onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      event.preventDefault();
    }} {...props} />);

const DisableAntTab = withStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: 0,
      textTransform: 'none',
      minWidth: 38,
      fontWeight: 'lighter',
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      minHeight: '35px',
      color: "#69768350",
      fontFamily: [
        'roboto-regular',
      ].join(','),
      '@media screen and (min-width: 375px) and (max-width: 599px)': {
        fontSize: 14,
        marginLeft: 5,
        marginRight: 5
      },
      '@media screen and (max-width: 374px)': {
        minWidth: 30,
        fontSize: 12,
        marginLeft: 4,
        marginRight: 4
      },
      '&:hover': {
        color: '#40a9ff',
        opacity: 1,
      },
      '&$selected': {
        color: '#017AEF',
        fontWeight: 'normal',
        fontFamily: 'roboto-bold'
      },
      '&:focus': {
        color: '#017AEF',
      },
    },
    selected: {},
  }),
)((props: StyledTabProps) =>
  <Tab disableRipple
    onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      event.preventDefault();
    }} {...props} />);

const AntTabs = withStyles((theme: Theme) => ({
  root: {
    margin: "0 auto",
    minHeight: 35,
    marginTop: theme.spacing(-2),
    paddingLeft: 65,
    '@media (max-width: 960px)': {
      paddingLeft: 0
    },
    '@media (max-width: 600px)': {
      marginTop: 0,
      paddingTop: 10,
      paddingBottom: 10
    },
  },
  indicator: {
    backgroundColor: '#1890ff',
    height: 3
  },
}))(Tabs);